<template>
  <div v-if="visible" class="cal-launcher">
    <!-- salvia-778: o dock e uma fileira de icones sem rotulo; sem a dica, so
         descobre o que cada um faz quem clica. O `v-tooltip` fica DENTRO do
         `.cal-launcher`, que segue sendo a raiz do componente e quem carrega o
         posicionamento. -->
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          color="primary"
          class="cal-fab"
          elevation="6"
          aria-label="Abrir a salvIA"
          v-bind="attrs"
          v-on="on"
          @click="open = true"
        >
          <v-icon>mdi-robot-happy-outline</v-icon>
        </v-btn>
      </template>
      <span>salvIA — assistente clínica</span>
    </v-tooltip>

    <ClinicalAssistantPanel v-model="open" :patient-id="patientId" />
  </div>
</template>

<script>
import ClinicalAssistantPanel from "@/features/assistant/ClinicalAssistantPanel.vue";

/**
 * Launcher global da salvIA (Salvia Agêntico T2.6).
 *
 * FAB flutuante disponível para o médico em qualquer tela. Quando o médico está
 * na ficha de um paciente (rota PatientProfileDetails), passa o `patientId` para
 * o painel já ter contexto; fora disso, abre em modo geral (o agente pede/confirma
 * o paciente). Empilhado acima do widget de recados (AssistantNotesWidget).
 */
export default {
  name: "ClinicalAssistantLauncher",
  components: { ClinicalAssistantPanel },
  data() {
    return { open: false };
  },
  computed: {
    userType() {
      return this.$store.getters["auth/userType"];
    },
    isAuthenticated() {
      return this.$store.getters["auth/isAuthenticated"];
    },
    visible() {
      // A salvIA é do MÉDICO (solo ou de clínica).
      return (
        this.isAuthenticated &&
        ["doctor_solo", "doctor_clinic"].includes(this.userType)
      );
    },
    patientId() {
      // Só quando estamos na ficha de um paciente específico.
      if (this.$route?.name === "PatientProfileDetails") {
        const id = Number(this.$route.params.id);
        return Number.isFinite(id) ? id : null;
      }
      return null;
    },
  },
};
</script>

<style scoped>
.cal-launcher {
  /* Nível 2 da coluna de atalhos flutuantes. A ordem e o colapso são decididos
     pelo FloatingDock, que redefine as variáveis --ds-fab-* de fora; aqui só
     ficam os valores de quando o dock não existe. */
  position: fixed;
  right: var(--ds-fab-right, 24px);
  bottom: var(--ds-fab-bottom-2, 152px);
  z-index: var(--ds-fab-z, 95);
}
.cal-fab {
  box-shadow: 0 6px 18px rgba(31, 77, 63, 0.28);
}
</style>
